import { Reveal, Overline, Chapter } from "../components/Reveal";
import { BuyerForm } from "../components/EnquiryForms";

const POINTS = [
    { t: "Objectives First", c: "Budget, purpose, timeline and risk appetite — settled before any project is discussed." },
    { t: "Context Before Inventory", c: "Location, developer, pricing and product fundamentals — examined before anything is recommended." },
    { t: "Curated Opportunities", c: "A shortlist you can compare properly, instead of a catalogue you can't." },
];

const ForInvestors = () => (
    <main data-testid="for-investors-page">
        <section className="bg-charcoal pb-20 pt-40 text-ivory md:pb-28 md:pt-52">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <Reveal>
                    <Overline>For Buyers &amp; Investors</Overline>
                    <h1 className="mt-6 max-w-3xl font-serif text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl">
                        Better Information. <span className="italic text-gold">Better Decisions.</span>
                    </h1>
                    <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-ivory/70">
                        LUXATI starts with your objective, not our inventory. You see fewer
                        opportunities — with more context behind each one.
                    </p>
                </Reveal>
            </div>
        </section>

        <section className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32">
            <div className="grid gap-12 md:grid-cols-3">
                {POINTS.map((p, i) => (
                    <Reveal key={p.t} delay={i * 0.12} className="border-t border-ink/15 pt-8">
                        <p className="font-serif text-sm italic text-gold">{String(i + 1).padStart(2, "0")}</p>
                        <h3 className="mt-3 font-serif text-2xl font-medium tracking-tight text-ink">{p.t}</h3>
                        <p className="mt-4 text-sm font-light leading-relaxed text-ink/65">{p.c}</p>
                    </Reveal>
                ))}
            </div>
        </section>

        <section className="border-t border-ink/10 bg-white/50">
            <div className="mx-auto grid max-w-[1400px] gap-16 px-6 py-24 md:grid-cols-12 md:px-12 md:py-36">
                <div className="md:col-span-5">
                    <Chapter number="01" label="Request a Consultation" />
                    <Reveal className="mt-10">
                        <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl">
                            Tell Us What You're <span className="italic text-gold">Looking For.</span>
                        </h2>
                        <p className="mt-8 max-w-md text-base font-light leading-relaxed text-ink/70">
                            Share your objectives and constraints. We will respond with the opportunities
                            that genuinely fit — and a clear view of the ones that don't.
                        </p>
                    </Reveal>
                </div>
                <Reveal delay={0.15} className="md:col-span-6 md:col-start-7 md:pt-20">
                    <BuyerForm testid="investors-buyer-form" />
                </Reveal>
            </div>
        </section>
    </main>
);

export default ForInvestors;
